"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = shallowEqual;

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function shallowEqual(previous, next) {
  if (previous === next) return true;

  if (previous === null || next === null || _typeof(previous) !== 'object' || _typeof(next) !== 'object') {
    return false;
  }

  if (Array.isArray(previous)) {
    if (!Array.isArray(next)) return false;
    if (previous.length !== next.length) return false;

    for (var i = 0; i < previous.length; i += 1) {
      if (next[i] !== previous[i]) return false;
    }
  }

  var prevKeys = Object.keys(previous);
  var nextKeys = Object.keys(next);
  if (prevKeys.length !== nextKeys.length) return false;

  for (var _i = 0; _i < prevKeys.length; _i += 1) {
    if (previous[prevKeys[_i]] !== next[nextKeys[_i]]) {
      return false;
    }
  }

  return true;
}